import $ from 'jquery';
window.jQuery = $;
window.$ = $;

require('bootstrap');

require('jquery-ui');
require('evol-colorpicker');
window.Cropper = require('cropperjs');

require('./show-password'); 
require('./open-hours'); 
require('./profiles'); 
require('./widget-colors'); 
require('./preview-selected-image'); 
require('./cropper'); 
require('./modal-tips'); 